import { render, staticRenderFns } from "./freeTrialDetail.vue?vue&type=template&id=0b8a296e&scoped=true&"
import script from "./freeTrialDetail.vue?vue&type=script&lang=js&"
export * from "./freeTrialDetail.vue?vue&type=script&lang=js&"
import style0 from "./freeTrialDetail.vue?vue&type=style&index=0&id=0b8a296e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8a296e",
  null
  
)

export default component.exports